module.exports = __webpack_public_path__ + "img/right-triangle.61803002.svg";